<template>
  <div class="block-bordering">
    <div class="dont-miss-block">
      <h3 class="dont-miss-title">{{ blockData.title }}</h3>
      <div
        v-for="(article, index) in blockData.dontmissblocks"
        :key="index"
        class="dont-miss-article"
      >
        <img
          v-if="article.image"
          :src="article.image['Src']"
          :alt="article.image['Alt']"
          class="dont-miss-article-image"
          @click="redirectionToArticle(article)"
        />
        <h3 class="dont-miss-article-title" @click="redirectionToArticle(article)">
          {{ article.articletitle }}
        </h3>
        <a
          class="dont-miss-article-description"
          :href="article.subtoplink"
          @click="taggingToArticleDontmiss(article)"
          >{{ article.subtopictitle }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dont-miss-block',
  props: {
    blockData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    redirectionToArticle(article) {
      dataLayer.push({ //eslint-disable-line
        event: 'uaevent',
        ecommerce: 'undefined',
        eventCategory: 'content page' + '::' + 'branding page',
        eventAction: `select::${article.subtopictitle.toLowerCase().trim()}`,
        eventLabel: `${[article.subtopictitle.toLowerCase().trim()]}::${[article.url.toLowerCase().trim()]}`,
        event_name: 'body_button_click',
        module_name: `${article.subtopictitle.toLowerCase().trim()}`,
        cta_name: `${article.subtopictitle.toLowerCase().trim()}`,
        link_url: `${article.url.toLowerCase().trim()}`,
      });
      window.location.href = article.url;
    },
    taggingToArticleDontmiss(article) {
      dataLayer.push({ //eslint-disable-line
        event: 'uaevent',
        ecommerce: 'undefined',
        eventCategory: 'content page' + '::' + 'branding page',
        eventAction: `select::${article.subtopictitle.toLowerCase().trim()}`,
        eventLabel: `${[article.subtopictitle.toLowerCase().trim()]}::${[article.url.toLowerCase().trim()]}`,
        event_name: 'body_button_click',
        module_name: `${article.subtopictitle.toLowerCase().trim()}`,
        cta_name: `${article.subtopictitle.toLowerCase().trim()}`,
        link_url: `${article.url.toLowerCase().trim()}`,
      });
    },
  },
};
</script>
